export const recordLabels = {
  device_hostname: { label: 'Hostname' },
  device_ip: { label: 'IP Address' },
  dstDevice_ip: { label: 'Dst. IP' },
  dstPort: { label: 'Dst. Port' },
  metadata_product: { label: 'Product' },
  metadata_vendor: { label: 'Vendor' },
  srcDevice_ip: { label: 'Src. IP' },
  srcPort: { label: 'Src. Port' },
};
